import React from 'react'
import PropTypes from 'prop-types'

import ProductSettings from './ProductSettings'
import ProductImages from './ProductImages'

const ProductCard = ({
  classes, product, closeProduct, openSettings, closeSettings, selectedOptions, selectOption, addToCart
}) => {
  const { id } = product
  let { buttonText } = product
  if (buttonText === '') {
    buttonText = 'More Options'
  }
  // console.log('productCard', product)
  const { title, price, description, pureDescription, images, options, available, productUrl, prevPrice } = product.details
  const pc = 'ou_product-card'
  const cart = pc + '__cart'

  const goToProductUrl = () => {
    window.open(productUrl, '_self')
  }

  const optionsLength = (options) ? options.length : 0

  const renderPrevPrice = () => {
    if (prevPrice && prevPrice !== price) {
      return (
        <span className={`${pc}__prev_price`} id={`ou_product_card_price_${id}`}>${prevPrice}</span>
      )
    }
  }

  const renderBottomButton = () => {
    if (!available) {
      return ( // Product is not available
        <div
          id={`ou_product_card_button_${id}`}
          className={`${pc}__buy-button`} disabled
        >
          Not Available
        </div>
      )
    } else if (optionsLength > 1 || (optionsLength === 1 && options[0].values.length > 1)) {
      return ( // Product has different variants
        <div
          id={`ou_product_card_button_${id}`}
          className={`${pc}__buy-button`}
          onClick={openSettings}
        >
          {buttonText && buttonText !== '' ? buttonText : 'More options'}
        </div>
      )
    } else if (productUrl && productUrl !== '') {
      return (
        <button
          id={`ou_product_card_button_${id}`}
          className={'ou_product-card__add-to-cart-button'}
          onClick={goToProductUrl}
        >
          {buttonText && buttonText !== '' ? buttonText : 'Buy now'}
        </button>
      )
    } else {
      return ( // Product has no variants => straight to shopping cart
        <button
          id={`ou_product_card_button_${id}`}
          className={'ou_product-card__add-to-cart-button'}
          onClick={addToCart}
        >
          Add to Cart {renderPrevPrice()}{price && `$${price}`}
        </button>
      )
    }
  }

  const renderTitlePrice = () => {
    if (Number.isNaN(price)) {
      return <span id={`ou_product_card_title_${id}`}>{title}</span>
    } else {
      return (
        <span>
          <span id={`ou_product_card_title_${id}`}>{title} </span>
          {renderPrevPrice()}
          <span id={`ou_product_card_price_${id}`}>${price}</span>
        </span>
      )
    }
  }


  // console.log('ProductCard render', product)
  const iOSinsta = /iPad|iPhone|iPod/ && /Instagram/.test(navigator.userAgent) && !window.MSStream
  return (
    <article className={classes}>
      <span className={`${pc}__close-button`} onClick={closeProduct} />
      <ProductImages images={images} variantsNum={optionsLength} id={id} />
      <div className={`${pc}__content-block` + (optionsLength > 1 ? ` ${pc}__content-block--${optionsLength}` : '')}>
        <div className={`${pc}__content-before`} />
        <div className={`${pc}__content ou_product_card_content_${id}`}>
          <div className={`${pc}__description-wrap`}>
            <div className={`ou_product-card__title ou_product_title_${id}`}>
              {renderTitlePrice()}
            </div>
            <div className={`${pc}__description-before`} />
            <div
              id={`ou_product_card_description_${id}`}
              className={`${pc}__description ou_product_description_${id} js-scroll`}
            >
              {iOSinsta && pureDescription ? pureDescription.replace(/<(?:.|\n)*?>/gm, '') : description}
            </div>
            <div className={`${pc}__description-after`} />
            {renderBottomButton()}
          </div>
          <ProductSettings
            product={product}
            selectedOptions={selectedOptions}
            selectOption={selectOption}
            addToCart={addToCart}
          />
          <div className={`${pc}__settings-back-link`} onClick={closeSettings} />
        </div>
        <div className={`${pc}__content-after`} />
        <div className={`${cart}-info`}>
          <div className={`${cart}-title`}>{title}</div>
          <div className={`${cart}-line`} />
          <div className={`${cart}-status`}>Added to cart</div>
        </div>
      </div>
    </article>
  )
}

ProductCard.propTypes = {
  product: PropTypes.object,
  classes: PropTypes.string,
  selectedOptions: PropTypes.object,
  closeProduct: PropTypes.func,
  openSettings: PropTypes.func,
  closeSettings: PropTypes.func,
  selectOption: PropTypes.func,
  addToCart: PropTypes.func
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/templates/outSide/components/products/ProductCard.js